<template>
  <div>
    <div class="tabs">
      <ul class="uiClrfix" v-if="lang == 'chs'">
        <li>
          <a href="./"> <svg-icon icon-class="home-filling" />首页</a>
        </li>
        <li><span>/</span><a class="cur">投资企业</a></li>
      </ul>
      <ul class="uiClrfix" v-else>
        <li>
          <a href="./"> <svg-icon icon-class="home-filling" />Home</a>
        </li>
        <li><span>/</span><a class="cur">Portfolio Companies</a></li>
      </ul>
    </div>
    <div class="center">
      <div class="article-700">
        <div class="banner"></div>
        <div class="cardBox_title">
          <span>投资企业</span>
        </div>
        <div class="cardBox"></div>
      </div>

      <div class="cardBox">
        <div
          class="card"
          v-for="(el, i) in portfolioCompanies"
          :key="i"
          @click="toDetials(el)"
          title="点击查看详情"
        >
          <img
            class="card_pic"
            :src="require('../assets/images/' + el.photoUrl + '.jpg')"
            alt=""
          />
          <div class="card_name" v-if="lang == 'chs'">{{ el.cTitle }}</div>
          <div class="card_name" v-else>{{ el.eTitle }}</div>
        </div>
      </div>
    </div>
    <div class="cardDetials" v-if="cardShow">
      <div class="detial_dialog">
        <div class="dialog_top">
          <div class="dialog_title" v-if="lang == 'chs'">企业详情</div>
          <div class="dialog_title" v-else>Company Details</div>
          <div class="dialog_close" @click="closeDialog()"></div>
        </div>
        <div class="dialog_contetn">
          <img
            :src="require('../assets/images/' + card.photoUrl + '.jpg')"
            class="dialog_contetn_pic"
          />
          <div class="dialog_contetn_text" v-if="lang == 'chs'">
            {{ card.cContent }}
          </div>
          <div
            class="dialog_contetn_text"
            v-else
            style="text-align: justify;
            text-justify: inter-character;"
          >
            {{ card.eContent }}
          </div>
          <div class="dialog_contetn_address">
            <span v-if="lang == 'chs'">企业官网：</span>
            <span v-else>Company website：</span>
            <a :href="card.toAdress"> {{ card.toAdress }} </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PortfolioCompanies",
  data() {
    return {
      lang: "",
      card: null,
      cardShow: false,
      portfolioCompanies: [
        {
          cTitle: "清科集团",
          eTitle: "Zero2IPO Group",
          photoUrl: "Zero2IPOGroup",
          cContent:
            "清科集团是中国领先的创业与投资综合服务平台及知名投资机构。清科集团业务包括研究咨询、数据产品、信息资讯、会议论坛、投资培训、投资银行、产业集聚、直接投资、母基金管理及资产管理。2020年12月清科集团分拆负责提供数据服务、营销服务、咨询服务及培训服务的综合股权投资服务平台的清科创业于港交所主板上公司，股票代码：01945.HK。",
          eContent:
            "Zero2IPO Group is a pioneer in China`s entrepreneurship and investment industry, and a well-respected institutional investor. Its business includes research and advisory services, data product, market intelligence, conference and forum, investment training, investment banking, industry collaboration and clustering, direct investment, FoF and asset management. In December 2020, Zero2IPO Group spun off and listed Zero2IPO Holdings, which operates its data, marketing, advisory and training service business on the Hong Kong Stock Exchange Mainboard, stock code: 01945.HK.",
          toAdress: "https://www.zero2ipo.com.cn",
        },
        {
          cTitle: "中国物流资产",
          eTitle: "China Logistics Property",
          photoUrl: "ChinaLogisticsProperty",
          cContent:
            "中国物流资产是国内最大的物流基础设施开发商及运营商之一，业务涵盖物流仓储基础设施设计、开发、租赁、经营和管理领域，并主要服务于生产、零售、电子商务及物流服务等领域的客户。公司2016年7月于港交主板上市公司。",
          eContent:
            "China Logistics Property is one of the largest logistics infrastructure and service providers in China. Its business includes design, development, leasing and management of modern logistics warehouses, servicing an broad base of customers in the manufacturing, retail, e-commerce and logistics service sectors. The company went public on the Hong Kong Stock Exchange Mainboard in July 2016.",
          toAdress: "https://tzgs.crmsc.com.cn/index.shtml",
        },
        {
          cTitle: "中通快递",
          eTitle: "ZTO Express",
          photoUrl: "ZTOExpress",
          cContent:
            "中通快递是一家以快递为核心业务，集跨境、快运、商业、云仓、航空、金融、智能、传媒、冷链等生态版块于一体的综合物流服务企业。2016年10月在美国纽约证券交易所上市，2020年9月在香港实现二次上市，股票代码：ZTO.US，02057.HK。",
          eContent:
            "ZTO Express is a leading express delivery company in China and one of the largest express delivery companies globally It provides express delivery service as well as other value-added logistics services through its extensive and reliable nationwide network in China covering over 96% of the cities and counties of the country. The company was listed on the New York Stock Exchange in October 2016 and achieved its secondary listing on the Hong Kong Stock Exchange Mainboard in September 2020, stock codes: ZTO.US and 02057.HK.",
          toAdress: "https://www.zto.com",
        },
        {
          cTitle: "拉卡拉",
          eTitle: "Lakala",
          photoUrl: "Lakala",
          cContent:
            "拉卡拉是国内首批获得央行颁发牌照的第三方支付企业、国内领先的金融科技企业，专注于整合信息科技，服务线下实体，从支付切入，全维度为中小微商户的经营赋能，向客户提供支付科技、金融科技、电商科技以及信息科技服务。公司于2019年4在深交所上市，股票代码：300773.CN。",
          eContent:
            "Lakala is one of the first domestic third-party payment companies to obtain a license from the Peoples’ Bank of China. As a leading domestic financial technology company, it focuses on integrating information technology to empower bricks and mortar stores. It approaches customers with payment access and upsell customers with a broad array of business solutions which address the needs of small, medium and micro merchants ranging from payment, financial, e-commerce and IT services.stock codes:300773.CN",
          toAdress: "https://www.lakala.com",
        },
        {
          cTitle: "豪威科技",
          eTitle: "OmniVision Technologies",
          photoUrl: "OmniVisionTechnologies",
          cContent:
            "豪威科技设计和开发用于移动电话、笔记本电脑、上网本和网络摄像头、安全和监控摄像头、娱乐，汽车和医学成像系统的数字成像产品。 2018年上交所上市公司韦尔股份（股票代码：603501.CN,501.HK）以21.78亿美元的价格收购豪威科技。",
          eContent:
            "OmniVision Technologies designs and develops digital imaging products for use in mobile phones, notebooks, netbooks and webcams, security and surveillance camera, entertainment, automotive and medical imaging systems. It was acquired by Will Semiconductor in 2018 for US$2.178 billion. The company is now trading as part of Will Semiconductor on the Shanghai Stock Exchange under stock code: 603501.CN,501.HK.",
          toAdress: "https://www.ovt.com",
        },
        {
          cTitle: "卓正医疗",
          eTitle: "Distinct Healthcare",
          photoUrl: "DistinctHealthcare",
          cContent:
            "卓正医疗是中国领先的高端综合性连锁专科医疗中心。采用线上、线下一体化服务的新模式，在北京、上海、广州、深圳、成都、重庆、武汉、长沙、苏州、杭州、宁波等城市运营近30家诊疗中心，服务涵盖内科及全科、外科、妇产科、儿科、齿科、皮肤科及医学美容、眼科、耳鼻喉科、个性化体检、日间手术、航空转运、国际转诊等多个类别。依托最新的信息技术及数据技术，卓正医疗正在重构医疗服务的交付模式，提供诊后在线随诊、线上问诊及药物配送、视频急诊、健康管理及慢病管理等线上线下融通的医疗服务，用科技更好地实践“回归医疗本原”的理念。股票代码: 2677.HK。",
          eContent:
            "DistinctHealthCare is China’s leading high-end medical service network, operating nearly 30 medical centers in major tier-1 and tier-2 cities such as Beijing, Shanghai, Guangzhou, Shenzhen, Chengdu, Chongqing, Wuhan, Changsha, Suzhou, Hangzhou, Ningbo and etc. With an integrated online-and-offline model, DistinctHealthcare provides a variety of medical services in internal medicine and general medicine, surgery, obstetrics and gynecology, pediatrics, dentistry, dermatology and medical beauty, ophthalmology, otolaryngology, personalized physical examination, day surgery, air transport, international referral, and other personalized medical services. By utilizing latest information technology, DistinctHealthcare is reshaping the delivery model of medical services, providing online follow-up, online consultation and drug distribution, emergent video consultation, health management and chronic disease management and other online and offline medical services.stock code: 2677.HK.",
          toAdress: "https://www.distinctclinic.com",
        },
        {
          cTitle: "Qumulo",
          eTitle: "Qumulo",
          photoUrl: "Qumulo",
          cContent:
            "Qumulo是适用于多云环境运作的领先档案数据平台，可以对大规模档案数据提供宽广、操控性高和实时可见化的运维和处理能力，其产品简化了十亿字节（EB）量级的高性能负荷非结构化档案数据管理工作。",
          eContent:
            "Qumulo is the leading file data platform for multicloud environments, providing unrivaled freedom, control and real-time visibility for file data at massive scale. Its products simplify unstructured file data management for high-performance workloads at exabyte scale.",
          toAdress: "https://www.qumulo.com",
        },
        // {
        //   cTitle: "Indeni",
        //   eTitle: "Indeni",
        //   photoUrl: "Indeni",
        //   cContent:
        //     "Indeni是安全基础架构自动化和原生云基础架构安全方面的领导者，以创新的基础构架安全管理和IaC（基础架构代码化）技术，将网络基础建设安全领域的最佳实践方法制作成可以自动化部署和执行的作业工具。",
        //   eContent:
        //     "Indeni is the leader in Security Infrastructure Automation and Native Cloud Infrastructure Security. It has pioneered a new way to manage security infrastructure and IaC (infrastructure as code) by providing the World's best practices, automated.",
        //   toAdress: "https://www.indeni.com",
        // },
        {
          cTitle: "爱琅医疗器械",
          eTitle: "Argon Medical Devices",
          photoUrl: "ArgonMedicalDevices",
          cContent:
            "爱琅医疗是一家国际领先的高端介入医疗器械提供商，总部位于德克萨斯州弗里斯科。 爱琅医疗 为介入放射科、血管外科、介入心脏病学和介入肿瘤科提供各种医疗器械解决方案。 爱琅的产品通过经皮介入和经图像引导介入改善患者的诊断和治疗效果，得到全球介入领域医生的广泛认可。爱琅拥有完善的销售和营销体系，与医疗器械分销商和战略合作伙伴一同为全球客户提供服务。爱琅医疗在全球拥有近 1000 名员工，在德克萨斯州雅典、惠灵、伊利诺伊州和纽约州罗切斯特设有制造工厂。",
          eContent:
            "Argon Medical is a global manufacturer of specialty medical products, headquartered in Frisco, Texas.  Argon offers a broad line of medical devices for Interventional Radiology, Vascular Surgery, Interventional Cardiology and Oncology.  Argon’s brand is recognized for best-in-class products that improve patient outcomes via percutaneous, image-guided procedures. By utilizing a well-established sales and marketing infrastructure, Argon serves its global customers through a direct sales organization and through long-standing relationships with medical device distributors, strategic partners and OEMs. With almost 1000 employees worldwide, Argon has manufacturing facilities located in Athens, Texas, Wheeling, IL and Rochester, NY.",
          toAdress: "https://www.argonmedical.com",
        },
        // {
        //   cTitle: "Sensel",
        //   eTitle: "Sensel",
        //   photoUrl: "Sensel",
        //   cContent:
        //     "Sensel正在构建新的触控技术范式，重新定义用户与计算机交互界面，以包括压力感应和多点触控技术应对普适计算的环境挑战，其产品将赋能用户，重置行业规律，并彻底改变用户与数字世界的互动。",
        //   eContent:
        //     "Sensel is building a new paradigm of touch technologies that will redefine computer interaction to include pressure sensitivity, multi-touch, and meet the environmental challenges of ubiquitous computing. Its products will empower users, disrupt industries, and revolutionize interaction with the digital world.",
        //   toAdress: "https://www.sensel.com",
        // },
        // {
        //   cTitle: "Leanplum",
        //   eTitle: "Leanplum",
        //   photoUrl: "Leanplum",
        //   cContent:
        //     "Leanplum领先的多渠道客户互动平台可帮助前瞻性品牌客户将数据转化为对用户需求的理解和制定可行市场营销计划满足用户的实时需求。",
        //   eContent:
        //     "Leanplum’s leading multi-channel customer engagement platform helps forward-looking brands transform data into an understanding of what users want and actionable programs to meet users’ real-time needs.",
        //   toAdress: "https://www.leanplum.com",
        // },
        // {
        //   cTitle: "HeadSpin",
        //   eTitle: "HeadSpin",
        //   photoUrl: "HeadSpin",
        //   cContent:
        //     "HeadSpin的全球设备云可以在全球100多个地区的真实电讯运营和WiFi网络环境上部署了数千个使用SIM终端进行移动应用和浏览器测试，让客户的开发、质量保证和产品团队在整个移动应用开发生命周期中确保最佳的用户体验。",
        //   eContent:
        //     "HeadSpin’s global device cloud enables mobile and browser testing on thousands of SIM-enabled devices deployed in 100+ locations on real carrier and WiFi networks around the globe. It empowers development, quality assurance and product teams to assure optimal user experiences throughout the app development lifecycle.",
        //   toAdress: "https://www.headspin.io",
        // },
        {
          cTitle: "联想DCG中国",
          eTitle: "Lenovo DCG China",
          photoUrl: "LenovoDCGChina",
          cContent:
            "联想DCG中国通过为用户提供高性能计算基础架构设备、企业解决方案和端到端服务，推动国家向智能化转型。",
          eContent:
            "Lenovo DCG China empowers intelligent transformation in the country by providing users with high performance computing infrastructure equipment, enterprise solutions and end-to-end services.",
          toAdress: "https://www.lenovo.com",
        },
        {
          cTitle: "云智慧",
          eTitle: "Cloudwise",
          photoUrl: "Cloudwise",
          cContent:
            "云智慧是提供高质量IT运营管理（ITOM）和IT服务管理（ITSM）解决方案的先驱，帮助客户深入了解其移动应用、网站、网络设施和数字服务的可用就绪状态和性能表现。",
          eContent:
            "Cloudwise is a pioneer in providing high quality IT operation management (ITOM) and IT service management (ITSM) solutions which help customers to gain insights into the readiness and performance of their apps, websites, networks and digital services.",
          toAdress: "https://www.cloudwise.com",
        },
        {
          cTitle: "根网科技",
          eTitle: "Rootnet Technology",
          photoUrl: "RootnetTechnology",
          cContent:
            "根网科技是一家证券行业核心软件及服务供应商，服务超过100多家国内外证券公司、基金、QFII等金融机构，致力构建连接资金端与资产端的完整生态。",
          eContent:
            "Rootnet Technology provides the securities industry with mission-critical technologies and services, serving more than 100 domestic and foreign securities firms, investment funds, QFII and other financial institutions. It is building a complete ecosystem which connects capital with investment opportunities.",
          toAdress: "https://www.crootway.com",
        },
        {
          cTitle: "光羿",
          eTitle: "Ambilight",
          photoUrl: "Ambilight",
          cContent:
            "光羿是新一代电致变色（EC）技术的领导者，开发和制造柔性可塑型EC薄膜，该薄膜可应用于各种智能玻璃解决方案，以实现美观，调节光亮度和颜色，视觉舒适，温度控制，节能和提高消遣活动体验。",
          eContent:
            "Ambilight is a leader in new-generation electrochromic (EC) technology. It develops and manufactures flexible and conformable EC thin film which can be tailored for various smart glass solutions for aesthetics, light management, visual comforts, temperature control, energy conservation and enhancement of experience in recreational activities.",
          toAdress: "https://www.ambilight.com",
        },
        {
          cTitle: "Lauffer",
          eTitle: "Lauffer",
          photoUrl: "Lauffer",
          cContent:
            "Lauffer是一家领先的液压机、电动压机和自动化系统制造商，其技术组合涵盖层压和材料复合、塑料加工和涂层、金属锻造和粉末成型工序。公司生产的机械广泛用于汽车、航空航天、石油化工、家用电器和新材料行业。",
          eContent:
            "Lauffer is a world-leading manufacturer of hydraulic press equipment. It is one of the most comprehensive high-end equipment manufacturers in the hydraulic press industry. The company's products include lamination, plastic processing and packaging, metal forging, powder molding and other specialty equipment, which are widely used in the automotive, aerospace, petrochemical, home appliances and new material industries.",
          toAdress: "https://www.lauffer.de",
        },
        {
          cTitle: "美中宜和医疗",
          eTitle: "Amcare",
          photoUrl: "Amcare",
          cContent:
            "美中宜和是一家领先的国际标准品质的高端医疗服务机构，为中国中高端家庭提供从孕前、分娩、产后休养、儿童保健、儿科疾病、辅助生殖、医学美容到家庭健康的全方位连续性专业服务，是国内分娩量领先的私立医院集团。",
          eContent:
            "Amcare Group is a leading high-end OB/GYN and Pediatrics hospital group with international standard quality. The company provides a full range of professional services for middle-to-high-end Chinese families, from pre-pregnancy consultation, parturition, postpartum recuperation, child healthcare, pediatric services, assisted reproduction, aesthetic medicine to family healthcare. It is a leading private hospital group in terms of delivery volume.",
          toAdress: "https://www.amcare.com.cn",
        },
        {
          cTitle: "惟视眼科",
          eTitle: "Visionly",
          photoUrl: "Visionly",
          cContent:
            "惟视眼科是中国领先的线上线下一体化的眼科和眼视光学诊疗平台。为了提高中国眼科医生的临床诊断和治疗水平，其在线业务部门拥有并运营中国最大的眼科移动医疗平台，致力于提供眼科领域最新的学术、临床和市场资讯，活跃用户目前占中国专业眼科医生的90%以上，在眼科领域具有重要影响力和良好声誉。借助于惟视线上平台的眼科医生网络资源，惟视眼科还在中国经营连锁眼科医院和诊所，提供的服务包括外眼表面疾病治疗、眼科整形手术、青少年近视预防和控制、屈光手术、高端白内障手术和其他高端眼科诊疗服务等。",
          eContent:
            "VisionlyPlus is China’s leading integrated online-and-offline medical platform in Ophthalmology and Optometry.  Aiming to enhance Chinese ophthalmologists’ clinical diagnosis and treatment standard, its online business unit owns and operates China’s largest ophthalmology mobile platform committed to providing latest academic, clinical and market information in the ophthalmology field. With active users currently composing over 90% of professional ophthalmologists in China, VisionlyPlus has significant influence and enjoys high reputation in the ophthalmology field. By leveraging its online resources of ophthalmologists network, VisionlyPlus also operates ophthalmology hospitals and clinics in China. Services offered include external ocular surface diseases treatment, ocular plastic surgery, youth myopia prevention and control, refractive surgery, high-end cataract surgery, and other high-end ophthalmology services.",
          toAdress: "https://www.visionly.org",
        },
        {
          cTitle: "热刺激光",
          eTitle: "Recilaser",
          photoUrl: "Recilaser",
          cContent:
            "热刺激光成是一家中国集激光系列产品的研制、开发和生产于一体的大型综合性工业激光器制造企业，也是一家具备核放射性膜层研究生产资质公司。公司总部研发中心位于北京，工厂位于河北燕郊及浙江台州温岭。",
          eContent:
            "Recilaser is a large comprehensive industrial laser manufacturing enterprise integrating the research, development and production of laser series products in China. It is also a nuclear radioactive film research and production qualification company. The R & D center of the company's headquarters is located in Beijing, and the factory is located in Yanjiao, Hebei and Wenling, Taizhou, Zhejiang.",
          toAdress: "https://www.recilaser.com",
        },
        {
          cTitle: "华云合创",
          eTitle: "Huayun Hechuang",
          photoUrl: "HuayunHechuang",
          cContent:
            "华云合创致力于建立开放的互联网+ SaaS中国企业协作服务平台，解决企业内部和企业间的协作问题。",
          eContent:
            "Huayun Hechuang operates an open Internet Plus SaaS platform to facilitate internal collaboration of Chinese enterprises. The platform also serves as a bridge for collaboration among Chinese enterprises for furthering mutual business interest.",
          toAdress: "https://www.isphere.top",
        },
        {
          cTitle: "文安智能",
          eTitle: "Vionvision",
          photoUrl: "Vionvision",
          cContent:
            "文安智能是一家将机器视觉技术应用于智慧零售和智慧城市的头部企业。",
          eContent:
            "Vionvision is a leader in computer vision technology for smart retail and smart city applications.",
          toAdress: "https://www.vion-tech.com",
        },
        {
          cTitle: "中感微",
          eTitle: "Zhong Gan Micro",
          photoUrl: "ZhongGanMicro",
          cContent: "中感微致力于传感网和物联网芯片技术和产品的研发。",
          eContent:
            "Zhong Gan Micro focuses on the research and development of sensor network and IoT technology and products.",
          toAdress: "https://www.zgmicro.com",
        },
        {
          cTitle: "智汇云舟",
          eTitle: "Smart Yunzhou",
          photoUrl: "SmartYunzhou",
          cContent:
            "智汇云舟提供基于三维地理信息进行大规模视频融合的技术和应用。",
          eContent:
            "Smart Yunzhou provides large scale video fusion technology and applications.",
          toAdress: "https://www.smartyunzhou.com",
        },
        {
          cTitle: "启迪半导体",
          eTitle: "Qidi Semiconductor",
          photoUrl: "QidiSemiconductor",
          cContent:
            "启迪半导体（现更名为：安徽长飞先进半导体有限公司）专注于碳化硅（SiC）功率半导体产品研发及制造。公司于2022年被长飞光纤光缆股份有限公司（股票代码：601869.SH、06869.HK）收购。",
          eContent:
            "Qidi Semiconductor (now known as Anhui Changfei Advanced Semiconductor Co., Ltd.) focuses on the research, development, and manufacturing of silicon carbide (SiC) power semiconductor products. It was acquired by Yangtze Optical Fiber and Cable Joint Stock Limited Company (Stock Code: 601869.SH, 06869.HK) in 2022.",
          toAdress: "https://www.yascsemi.com",
        },
        {
          cTitle: "联想至像",
          eTitle: "Lenovo Image",
          photoUrl: "LenovoImage",
          cContent:
            "联想至像通过其融合硬件、技术和应用的智能终端为用户提供最佳的图像处理输出服务和体验。",
          eContent:
            "Lenovo Image provides customers with the best image processing, output services, and experience through its intelligent terminals which integrate hardware, technology, and applications into one offering.",
          toAdress: "https://www.lenovoimage.com",
        },
        {
          cTitle: "睿思芯科",
          eTitle: "RiVAI Technology",
          photoUrl: "RiVAITechnology",
          cContent: "睿思芯科是一家提供RISC-V高端核心处理器解决方案的公司。",
          eContent:
            "RiVAI Technology provides customers with RISC-V high-end core processor solutions.",
          toAdress: "https://www.rivai-ic.com.cn",
        },
        {
          cTitle: "博创智能",
          eTitle: "Borch Machinery",
          photoUrl: "BorchMachinery",
          cContent: "博创智能专注于注塑成型装备和智能制造系统的设计和制造。",
          eContent:
            "Borch Machinery specializes in the design and manufacturing of injection molding machines and intelligent manufacturing systems.",
          toAdress: "https://www.borche.cn",
        },
        {
          cTitle: "艺妙神州",
          eTitle: "Imunopharm",
          photoUrl: "Imunopharm",
          cContent:
            "艺妙神州致力于将创新的基因细胞药物技术应用于恶性肿瘤治疗，是CAR-T技术领域的领先医疗科技企业。",
          eContent:
            "Imunopharm, a leading CAR-T med-tech company, develops innovative gene and cell therapies for curing malignant tumors.",
          toAdress: "https://www.immunochina.com",
        },
        {
          cTitle: "睿力集成",
          eTitle: "CXMT",
          photoUrl: "CXMT",
          cContent:
            "睿力集成是一家一体化存储器制造商，专业从事动态随机存取存储芯片（DRAM）的设计、研发、生产和销售。",
          eContent:
            "CXMT is an integrated design and manufacturing company specializing in the design, research and development, manufacturing, and sale of dynamic random-access memory (DRAM).",
          toAdress: "https://www.cxmt.com",
        },
        {
          cTitle: "品驰医疗",
          eTitle: "PINS Medical",
          photoUrl: "PINSMedical",
          cContent:
            "品驰医疗是专业从事脑起搏器、迷走神经刺激器、脊髓刺激器、骶神经刺激器等系列化神经调控产品研发、生产和销售的领先医疗科技企业。",
          eContent:
            "PINS Medical is a leading neuromodulation med-tech company. Its clinical products and offerings include stimulators for deep brain, vagus nerve, spinal cord, and sacral nerve stimulation therapies.",
          toAdress: "https://www.pinsmedical.com",
        },
        // {
        //   cTitle: "华科精准",
        //   eTitle: "Sinovation",
        //   photoUrl: "Sinovation",
        //   cContent: "华科精准专注于为神经外科手术提供智能解决方案。",
        //   eContent:
        //     "Sinovation specializes in providing intelligent solutions for neurosurgery.",
        //   toAdress: "https://www.sinovationmed.com",
        // },
        // {
        //   cTitle: "奇瑞控股",
        //   eTitle: "Chery Holding",
        //   photoUrl: "CheryHolding",
        //   cContent: "奇瑞控股是一家以汽车产业链为核心的多元化企业集团。",
        //   eContent:
        //     "Chery Holding is an auto-centric conglomerate with divested business operations spanning across the entire auto ecosystem.",
        //   toAdress: "https://www.chery.cn",
        // },
        // {
        //   cTitle: "荣正咨询",
        //   eTitle: "REALIZE",
        //   photoUrl: "REALIZE",
        //   cContent: "荣正咨询为其中国企业客户提供股权激励和市值管理咨询服务。",
        //   eContent:
        //     "REALIZE advices its Chinese corporate clients on stock incentive plan and market capitalization management.",
        //   toAdress: "https://www.realize.com.cn",
        // },
        // {
        //   cTitle: "WizRocket",
        //   eTitle: "WizRocket",
        //   photoUrl: "WizRocket",
        //   cContent:
        //     "WizRocket 通过其 CleverTap平台向企业客户提供一体化用户分析、画像细分和提高参与度的营销和管理工具，使企业客户能够与其用户客户建立长期及有价值的关系。",
        //   eContent:
        //     "WizRocket is the operator of CleverTap, an all-in-one customer engagement platform which offers the analytics, segmentation, and engagement tools to enable its clients to build valuable, long-term relationships with their customers.",
        //   toAdress: "https://www.clevertap.com",
        // },
        {
          cTitle: "图达通",
          eTitle: "Seyond",
          photoUrl: "Seyond",
          cContent:
            "图达通是全球领先的图像级激光雷达（LiDAR）供应商，业务涵盖高性能激光雷达的研发、生产、销售及相关感知软件的开发，产品广泛应用于自动驾驶、智能交通、车路协同等领域。股票代码: 2665.HK。",
          eContent:
            "Seyond is a world-leading provider of image-grade LiDAR systems. It specializes in R&D, production, and sales of high-performance LiDAR sensors and perception software, serving customers in the autonomous driving, smart transportation, and V2X sectors.stock code: 2665.HK. ",
          toAdress: "https://www.seyond.cn",
        },
        {
          cTitle: "北京华封集芯",
          eTitle: "HFIe",
          photoUrl: "HFIe",
          cContent:
            "华封集芯是国内专注于先进封装与异构集成解决方案的高端半导体制造企业。业务覆盖晶圆凸点制造、2.5D/3D 先进封装、全流程测试、封装设计、仿真验证及失效分析，提供从协同设计到量产交付的一站式全流程服务。公司服务高性能计算、人工智能、半导体制造、封测等领域客户，拥有平均二十年以上行业经验的资深专家团队、自主核心技术体系与规模化智能量产能力，是北京市专精特新与创新型中小企业。",
          eContent:
            "HFIe is a leading solution provider and high-end semiconductor manufacturer focused on advanced packaging and heterogeneous integration in China. Its core business covers wafer bumping, 2.5D/3D advanced packaging, full‑chain testing, packaging design, simulation verification, and failure analysis, delivering one‑stop services from collaborative design to mass production delivery. The company serves customers across high-performance computing, artificial intelligence, semiconductor manufacturing, and OSAT sectors, backed by a senior expert team with over 20 years of global experience, strong independent R&D, and large‑scale intelligent manufacturing capacity. ",
          toAdress: "https://www.hfie.com/",
        },
        {
          cTitle: "江苏为恒智能",
          eTitle: "Weiheng",
          photoUrl: "Weiheng",
          cContent:
            "江苏为恒智能是领先的全场景储能系统解决方案供应商，业务涵盖工商业储能、户用储能及微电网系统的设计、研发、集成和运营管理，主要服务于能源投资、公用事业及工业企业等领域的客户。公司致力于通过数字化技术优化能源资产，助力全球能源结构向低碳转型。",
          eContent:
            "Weiheng is a leading provider of all-scenario energy storage system (ESS) solutions. Its business includes the design, R&D, integration, and operational management of C&I ESS, residential ESS, and microgrid systems, servicing customers in the energy investment, utility, and industrial sectors. The company is dedicated to optimizing energy assets through digital technology to support the global transition to a low-carbon energy structure.",
          toAdress: "https://www.whes.com/",
        },
        {
          cTitle: "无锡朗贤",
          eTitle: "Longshine",
          photoUrl: "Longshine",
          cContent:
            "无锡朗贤是国内卓越的汽车轻量化技术解决方案提供商，业务涵盖高强度钢热冲压模具研发、零部件设计与生产以及轻量化工艺咨询，主要服务于乘用车及新能源汽车整车制造商。公司通过技术创新助力汽车行业实现减重降耗与安全性能的提升。",
          eContent:
            "Longshine is a prominent provider of automotive lightweight technology solutions in China. Its business includes the R&D of high-strength steel hot stamping molds, component design and production, and lightweight process consultancy, servicing OEMs in the passenger vehicle and new energy vehicle (NEV) sectors. The company leverages technical innovation to help the automotive industry achieve weight reduction, energy efficiency, and enhanced safety performance.",
          toAdress: "http://www.langshion.com",
        },
        {
          cTitle: "江苏奇纳新材料",
          eTitle: "Qina",
          photoUrl: "Qina",
          cContent:
            "江苏奇纳新材料是高性能特种合金材料领域的领军企业，业务涵高温合金母合金、丝材、制氢电极网和催化剂等高端特种金属材的研发、熔炼、精密铸造及深加工，主要服务于航空航天、医疗器械、燃气轮机、化工及氢能等高端制造领域。公司致力于成为全球高端金属材料优质供应商。",
          eContent:
            "Qina is a leading enterprise in the field of high-performance specialty alloy materials. Its business includes the R&D, melting, precision casting, and deep processing of superalloys and corrosion-resistant alloys, servicing customers in the aerospace, medical devices, gas turbine, and chemical sectors. The company is committed to providing high-quality, localized material solutions for high-end manufacturing.",
          toAdress: "https://www.qinalloy.com",
        },
        {
          cTitle: "四川腾盾科创",
          eTitle: "Tengden",
          photoUrl: "Tengden",
          cContent:
            "四川腾盾科创是国内领先的大型无人机研发制造及运营服务商，业务涵盖固定翼与旋翼大型无人机系统的设计、生产、飞行保障及行业应用开发，主要服务于应急救援、气象服务、物流运输及特种任务等领域的客户。公司以技术创新引领大型无人机的产业化应用。",
          eContent:
            "Tengden is a leading developer, manufacturer, and operator of large-scale UAV (Unmanned Aerial Vehicle) systems in China. Its business includes the design, production, flight support, and application development of large fixed-wing and rotor-wing UAVs, servicing customers in emergency rescue, meteorological services, logistics, and special mission sectors. The company leads the industrial application of large UAVs through continuous technological innovation.",
          toAdress: "https://www.tengden.com",
        },
        {
          cTitle: "无锡邑文微电子",
          eTitle: "AMTE",
          photoUrl: "AMTE",
          cContent:
            "无锡邑文微电子是国内领先的半导体前道工艺设备供应商，业务涵盖等离子刻蚀（Etch）、化学气相沉积（CVD）、原子层沉积（ALD）等设备的研发、生产及技术支持，主要服务于集成电路、第三代半导体及MEMS领域的客户。公司致力于实现半导体核心工艺设备的自主可控。",
          eContent:
            "AMTE is a leading provider of semiconductor front-end process equipment in China. Its business includes the R&D, production, and technical support of plasma etching, CVD, and ALD equipment, servicing customers in the IC, wide-bandgap (3rd Gen) semiconductor, and MEMS sectors. The company is dedicated to achieving independence and controllability in core semiconductor process equipment.",
          toAdress: "https://www.amteglobal.cn",
        },
        {
          cTitle: "芯合半导体",
          eTitle: "XHPsemi",
          photoUrl: "XHPsemi",
          cContent:
            "芯合半导体是高性能碳化硅功率半导体IDM企业，业务涵盖碳化硅晶圆、碳化硅二极管、碳化硅MOSFET以及全碳化硅功率模块等高端系列产品的研发、生产与销售，致力于构建覆盖全产业链的服务体系。",
          eContent:
            "XHPsemi is an IDM company focusing on SiC power chips, including chip design, wafer manufacturing, packaging and testing. Its products include wafers, SBD devices, MOSFET devices and all-SiC modules. The company is dedicated to providing completely semiconductor solutions for the high efficiency, miniaturization and lightweight of high-power density power conversion systems.",
          toAdress: "http://www.xhpsemi.com",
        },
        {
          cTitle: "芜湖造船厂",
          eTitle: "Wuhu Shipyard",
          photoUrl: "WuhuShipyard",
          cContent:
            "芜湖造船厂是中国极具历史底蕴且现代化的综合性造船企业，业务涵盖军用舰船、民用船舶及海洋工程装备的研发、设计、建造和维修，主要服务于国防建设、全球航运及能源开发领域的客户。作为“百年老店”，公司目前专注于高端化、绿色化、智能化的船舶制造升级。",
          eContent:
            "Wuhu Shipyard is one of China's most historic and modern integrated shipbuilding enterprises. Its business includes the R&D, design, construction, and repair of naval vessels, commercial ships, and offshore engineering equipment, servicing customers in national defense, global shipping, and energy development sectors. As a century-old shipyard, it now focuses on the upgrading of high-end, green, and intelligent shipbuilding.",
          toAdress: "http://www.wuhu.com.cn",
        },
        {
          cTitle: "清微智能",
          eTitle: "Tsing Micro",
          photoUrl: "TsingMicro",
          cContent:
            "清微智能专注于国产原创的可重构芯片的研发和产业应用，面向AI智算中心、大模型、自动驾驶、智能制造等场景提供算力支持，致力于打造国产原创、自主可控的可重构通用计算生态。",
          eContent:
            "Tsing Micro Technology Co., Ltd. specializes in the R&D and industrial application of domestically original reconfigurable chips (Reconfigurable Processing Unit, RPU). It provides computing power support for scenarios such as AI intelligent computing centers, large models, autonomous driving, and intelligent manufacturing, and is committed to building a domestically original, independently controllable reconfigurable general computing ecosystem.",
          toAdress: "http://www.tsingmicro.com",
        },
        {
          cTitle: "北京凌川科技",
          eTitle: "Transtreams",
          photoUrl: "Transtreams",
          cContent:
            "北京凌川科技是一家从事AI算力芯片的研发、设计、销售，基于自研芯片、集成板卡、定制化服务器等算力基础硬件设施，为用户提供一体化软件平台和系统框架方案的全场景支持服务供应商。",
          eContent:
            "Transtreams is a service provider specializing in the R&D, design and sales of AI computing power chips. Based on self-developed chips, integrated boards, customized servers and other computing power infrastructure hardware, it provides users with one-stop software platforms and systematic framework solutions with full-scenario support.",
          toAdress: "https://www.transtreams.com",
        },
        {
          cTitle: "勇芯科技",
          eTitle: "Yongxin",
          photoUrl: "Yongxin",
          cContent:
            "勇芯科技是一家面向 AIoT场的芯片级解决方案提供商，核心业务为基于 Chiplet技术开展模块化物联网芯片设计。依托先进封装技术实现多颗功能芯片的集成，公司为医疗健康、智能家居、工业控制等领域客户，提供高性能、低功耗的定制化芯片及配套供应链服务。",
          eContent:
            "Yongxin is a prominent provider of advanced packaging and testing services for power semiconductors in China. Its business includes the design, process development, and large-scale production of IGBT and Silicon Carbide (SiC) power modules, servicing customers in the new energy vehicle, photovoltaic energy storage, and industrial automation sectors. The company focuses on high-density integration and thermal management of power devices to support the green transition of the power electronics industry.",
          toAdress: "http://www.bravechip.com",
        },
        {
          cTitle: "深圳璇玑动力",
          eTitle: "Astrall",
          photoUrl: "Astrall",
          cContent:
            "深圳璇玑动力是国内领先的机器人核心动力系统及智能机器人研发商，业务涵盖高能量密度执行器、伺服驱动器及足式机器人整机的设计与开发，主要服务于应急救援、公共安全及科研教育等领域的客户。公司通过底层运动控制算法的持续创新，致力于推动机器人技术的产业化应用。",
          eContent:
            "Astrall is a leading developer of core robotic power systems and intelligent robots in China. Its business includes the design and development of high-energy-density actuators, servo drivers, and complete legged robot systems, servicing customers in the emergency rescue, public safety, and scientific research sectors. Through continuous innovation in underlying motion control algorithms, the company is committed to advancing the industrial application of robotic technology.",
          toAdress: "https://www.astralldynamics.cn",
        },
        {
          cTitle: "時的科技",
          eTitle: "TCab Tech",
          photoUrl: "TCabTech",
          cContent:
            "時的科技 是國內領先的垂直起降飛行器（eVTOL）研發商，業務涵蓋傾轉旋翼電動飛機的設計、研發、製造及低空經濟基礎設施的佈局，主要服務於空中通勤、旅遊觀光及應急救援等領域的客戶。公司致力於通過提供安全、便捷、環保的空中出行解決方案，打造未來城市空中交通（UAM）生態。",
          eContent:
            "TCab Tech is a leading developer of electric vertical takeoff and landing (eVTOL) aircraft in China. Its business includes the design, R&D, and manufacturing of tilt-rotor electric aircraft, as well as the layout of low-altitude economy infrastructure, servicing customers in air commuting, tourism, and emergency rescue sectors. The company is committed to creating a future Urban Air Mobility (UAM) ecosystem by providing safe, convenient, and eco-friendly aerial transportation solutions.",
          toAdress: "http://www.tcabtech.com",
        },
        {
          cTitle: "維度AI",
          eTitle: "Dimension AI",
          photoUrl: "DimensionAI",
          cContent:
            "维度 AI 是聚焦高强度知识工作的研学领域 AI 大模型应用，基于自研科学深度推理算法，为学者、科研、专业研学领域用户提供可溯源、经同行评审的学术级解决方案。项目依托全球超 2.5 亿篇学术文献（含 Nature、Science 核心期刊及 arXiv 数据库），从根源解决 AI 幻觉问题，可实现复杂公式推导、跨学科知识关联、假设验证与文献深度解析，面向全球高校、科研机构、企业研发部门及个人知识工作者，提供 AI 研学助手、AI 研学检索、维度空间 AI 辅助解析三大核心服务，助力学术研究、文献综述、实验设计、论文创作全流程提质增效，致力于构建自主通用人工智能应用体系，推动 AGI 自主科学研究与探索落地。",
          eContent:
            "Dimension AI is an AI large model application dedicated to high-intensity knowledge work and academic research. Relying on self-developed scientific deep reasoning algorithms, it delivers traceable and peer-reviewed academic solutions for scholars, researchers and professional users. With access to over 250 million global academic literatures (including top journals such as Nature, Science and arXiv database), it fundamentally eliminates AI hallucinations, and supports complex formula derivation, interdisciplinary knowledge connection, hypothesis verification and in-depth literature analysis. Serving global universities, research institutions, corporate R&D departments and individual knowledge workers, it provides three core services: AI Academic Assistant, AI Academic Search, and Dimension Space AI-assisted Analysis. Dimension AI aims to improve efficiency and quality throughout the entire process of academic research, literature review, experimental design and paper writing, while building an agentic AGI application system to enable autonomous scientific research and exploration powered by general artificial intelligence.",
          toAdress: "https://weidusci.com/ask/index",
        },
        {
          cTitle: "美新半导体",
          eTitle: "memsic",
          photoUrl: "memsic",
          cContent:
            "美新半导体主要从事MEMS传感器研发、生产及销售。公司目前的核心产品包括成熟产品AMR 地磁传感器、热式加速度计、电容式加速度计、低功耗霍尔开关，以及新研发产品六轴IMU 惯性测量单元、eOIS 影像稳定驱动和控制器。公司产品广泛应用于汽车、工业、医疗、可穿戴、智能家居、具身智能、消费电子等多个领域。",
          eContent:
            "MEMSIC is primarily engaged in the research, development, production, and sales of MEMS sensors. The company's core product portfolio features established lines such as AMR geomagnetic sensors, thermal accelerometers, capacitive accelerometers, and low-power Hall switches, alongside newly developed products including 6-axis IMU (Inertial Measurement Units) and eOIS (Electronic Optical Image Stabilization) drivers and controllers. Its products are widely utilized across various sectors, including automotive, industrial, medical, wearables, smart home, embodied AI, and consumer electronics.",
          toAdress: "http://www.memsic.com",
        },
      ],
    };
  },
  methods: {
    toDetials(el) {
      this.card = el;
      this.cardShow = true;
    },
    closeDialog() {
      this.cardShow = false;
    },
  },
  mounted() {
    let lang = sessionStorage.getItem("lang");
    if (lang) {
      this.lang = lang;
      this.$store.commit("setLang", lang);
    } else {
      this.lang = "chs";
      this.$store.commit("setLang", "chs");
    }
    this.portfolioCompanies.reverse();
  },
  computed: {
    listenData() {
      return this.$store.state.lang;
    },
  },
  watch: {
    listenData(newVal) {
      this.lang = newVal;
    },
  },
};
</script>

<style scoped>
.tabs {
  width: 1200px;
  padding: 0 15px;
  margin: 15px auto;
  height: 19px;
}

.tabs ul li {
  float: left;
}

.tabs ul li:nth-child(1):hover a {
  color: #233a78;
}

.tabs ul li span {
  padding: 0 5px;
}

.tabs ul li a {
  color: #999;
  font-size: 14px;
}

.tabs ul li .cur {
  color: #333;
  font-size: 14px;
}
.center {
  width: 1200px;
  margin: auto;
  background: #fff;
  padding-bottom: 30px;
  box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
}
.center .article-700 {
  width: 724px;
  margin: 0 auto;
  background: #fff;
  padding-top: 30px;
}

.center .article-700 .banner {
  width: 724px;
  height: 230px;
  background-image: url("../assets/images/banner.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.center .article-700 .cardBox_title {
  height: 42px;
  line-height: 42px;
  font-size: 18px;
  color: #333;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
  margin: 15px 0;
}

.center .cardBox {
  width: 724px;
  margin: 0 auto;
}

.center .card {
  display: inline-block;
  width: 162px;
  height: 137px;
  margin: 8px 6px;
  border: 1px solid #d7e1fc;
  cursor: pointer;
}

.center .card .card_pic {
  height: 80px;
  margin: 13px 0;
}

.center .card .card_name {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  background: #2f4d9f;
  color: #fff;
  text-align: center;
  font-weight: bold;
}

.center .card:hover .card_name {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  background: #eee;
  color: #2f4d9f;
  text-align: center;
  font-weight: bold;
}

.center .card .card_name2 {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  background: #2f4d9f;
  color: #fff;
  text-align: center;
}

.center .card:hover .card_name2 {
  height: 30px;
  line-height: 30px;
  font-size: 18px;
  font-size: 12px;
  background: #eee;
  color: #2f4d9f;
  text-align: center;
}
.cardDetials {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
}

.cardDetials .detial_dialog {
  width: 645px;
  min-height: 100px;
  margin: 20vh auto 0;
  background: #fff;
  padding: 20px;
}

.cardDetials .detial_dialog .dialog_top {
  height: 36px;
  line-height: 24px;
  border-bottom: 1px solid #eee;
  position: relative;
}

.cardDetials .detial_dialog .dialog_top .dialog_title {
  font-size: 18px;
  color: #333;
}
.cardDetials .detial_dialog .dialog_top .dialog_close {
  position: absolute;
  right: 0;
  top: 2px;
  width: 20px;
  height: 20px;
  background-image: url("../assets/images/close.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  cursor: pointer;
}
.cardDetials .detial_dialog .dialog_contetn .dialog_contetn_pic {
  width: 160px;
  height: 80px;
  margin: 20px auto;
}
.cardDetials .detial_dialog .dialog_contetn .dialog_contetn_text {
  margin: 10px 0 30px;
}
.cardDetials .detial_dialog .dialog_contetn .dialog_contetn_address {
  margin: 10px 0 30px;
}
.cardDetials .detial_dialog .dialog_contetn .dialog_contetn_address a {
  width: 300px;
  color: #233a78;
}
</style>
